import axios from 'axios'

const analyze = axios.create({
    baseURL: `${process.env.VUE_APP_URL_ANALYZE}`
});

export default analyze